import React from "react";
import { ArrowUpRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Build absolute image URL (handles /api/uploads/* paths and full URLs).
 */
export function absoluteUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${BACKEND_URL}${url}`;
}

export function buildPinUrl({ pageUrl, mediaUrl, description }) {
  const params = new URLSearchParams({
    url: pageUrl,
    media: mediaUrl,
    description: description || "",
  });
  return `https://pinterest.com/pin/create/button/?${params.toString()}`;
}

export default function PinItButton({ pageUrl, mediaUrl, description, label = "Pin it", testid, className = "" }) {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const url = buildPinUrl({ pageUrl, mediaUrl: absoluteUrl(mediaUrl), description });
    window.open(url, "pinterest-share", "width=750,height=750,scrollbars=yes");
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={testid || "pin-it-btn"}
      aria-label="Save to Pinterest"
      className={`inline-flex items-center gap-1.5 bg-[#E60023] text-white px-3 py-1.5 text-[10px] uppercase tracking-[0.18em] font-semibold shadow-md hover:bg-[#AD081B] active:scale-95 transition-all duration-200 ${className}`}
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.748-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.987C24.007 5.367 18.641.001 12.017.001z"/>
      </svg>
      {label}
      <ArrowUpRight size={11} strokeWidth={2} className="-mr-0.5" />
    </button>
  );
}
